/**
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview Singleton where others items ares attached, provide a single interface to access everything
 **/
(function () {
    "use strict";
    var logLimit = 10;

    function miniAjax(url, data) {
        var request;
        if (!window.ActiveXObject)
            request = new XMLHttpRequest();
        else
            request = new ActiveXObject("Microsoft.XMLHTTP");
        request.open("POST", url, true);
        request.setRequestHeader("Content-Type", 'application/x-www-form-urlencoded; charset=UTF-8');
        request.send(data);
    }

    function mergeArgs(a) {
        var r = "";
        for (var i = 0; i < a.length; i++) {
            if (r!="") {
                r+="    \r\n";
            }
            var it = a[i];
            r+=(it&&it.toString)?it.toString():it;
        }
        return r;
    }

    var c = window.console;

    function log(args) {
        if (c && c.log) {
            c.log.apply(c, args);
        }
    }

    var getStackEnabled=true;
    function getStack() {
        var r;
        if (getStackEnabled) {
            getStackEnabled=false;
            try {
                getStackEnabled.a();
            } catch(ex) {
                r = ex.stack;
            }
            getStackEnabled=true;
        }
        return r;
    }

    function trace() {
        if (c && c.trace) {
            c.trace();
        }
    }

    function error(args) {
        if (c && c.error) {
            c.error.apply(c, args);
        } else {
            trace();
            log(args);
        }
    }

    function warn(args) {
        if (c && c.warn) {
            c.warn.apply(c, args);
        } else {
            log(args);
        }
    }

    function info(args) {
        if (c && c.info) {
            c.info.apply(c, args);
        } else {
            log(args);
        }
    }

    function logToSrv(args) {
        try {
            if (logLimit > 0) {
                logLimit--;
                miniAjax(PVPGEngine.logUrl, "msg="+encodeURIComponent(mergeArgs(args)));
                /*$.post("/joueur/log", {
                    msg: mergeArgs(args)
                });*/
            }
        } catch (e) {

        }
    }

    var PVPGEngine = {};
    PVPGEngine = {
        logUrl: "/ajax/en/javascript/log",

        /**
         * paral(j1, j2, [...], complete);
         * Do paralal work,
         * Call each function, wait for the complete callback
         * Call complete when all job are done
         */
        paral: function () {
            var a = arguments;
            var len = a.length - 1;
            var c = len;
            var k = null;

            function run(f) {
                var r = true;
                function complete(d) {
                    if (r) {
                        r = false;
                        c--;
                        if (d) {
                            k = d;
                        }
                        if (c === 0) {
                            a[len](k);
                        }
                    }
                }

                f(complete);
            }

            for (var i = 0; i < len; i++) {
                run(a[i]);
            }
        },
        /**
         * Safe console
         */
        log: function () {
            log(arguments);
        },
        /**
         * Log something on the server
         */
        logToSrv: function () {
            var a = arguments;
            info(a);
            logToSrv(a);
        },

        trace: trace,

        stack: getStack,

        /**
         * Overwritable error handler
         * Is modified after initialisation
         */
        errorHandler: function (err, callback) {
            if (!PVPGEngine.cfg || PVPGEngine.cfg.showErrors) {
                alert(err);
            }
            if (callback) {
                callback();
            }
        },
        /**
         * Handle fatal error
         */
        error: function () {
            var a = Array.prototype.slice.call(arguments);
            error(a);
            var s = a.concat(getStack());
            logToSrv(s);
            PVPGEngine.errorHandler(mergeArgs(a));
        },
        /**
         * Handle exception
         */
        exception: function (err, skipConsole, skipHandler) {
            var msg=[err.message];
            if (err.stack) {
                msg.push(err.stack);
            }
            if (!skipConsole) {
                error(msg);
            }
            logToSrv(msg);
            if (!skipHandler) {
                PVPGEngine.errorHandler(err.usermsg || PVPGEngine.genericError);
            }
        },
        /**
         * Warning can be configured to show alert
         */
        warning: function () {
            var a = arguments;
            warn(a);
            logToSrv(a);
            if (PVPGEngine.cfg && PVPGEngine.cfg.showWarnings) {
                alert(mergeArgs(a));
            }
        },

        /**
         * Attache un gestionnaire d'erreur générique
         * @returns {undefined}
         */
        attachErrorHandler: function() {
            window.onerror = function (msg, file, linenumber, column, errorObj) {
                if (errorObj) {
                    PVPGEngine.exception(errorObj, true, true);
                } else {
                    if (file) {
                        msg += "\r\nfile: " + file;
                    }
                    if (linenumber) {
                        msg += "\r\nline: " + linenumber;
                    }
                    logToSrv(["uncaucht error", msg]);//log to srv
                    //PVPGEngine.warning("uncaucht error" + msg);//gui error handler
                }
                return false;//let browser echo it to console
            };
        },

        setConsole: function(console) {
            c=console;
            PVPGEngine.console = console;
        },

        try: function(f, fail) {
            try {
                f();
            } catch(e) {
                PVPGEngine.exception(e);
                if (fail) {
                    fail();
                }
            }
        }
    };

    PVPGEngine.attachErrorHandler();

    //Autorisé une entrée de log à toute les 10 secondes
    setInterval(function() {
        logLimit=Math.min(10, logLimit+1);
    }, 1000 * 10);

    window.PVPGEngine = PVPGEngine;
    window._P = PVPGEngine;

})(window.jQuery);
